import { I18n } from '@calendly/i18n';
import { AdminIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { colorIconSecondary, colorTextStandard } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const styledAdminIconCss = "sbqndp9";
const StyledAdminIcon = forwardRef((props, ref) => <AdminIcon ref={ref} {...props} className={classNames(styledAdminIconCss, props.className)} />);
const wrapperPillStyleCss = "w9x91kd";
const wrapperCss = "wazuzwa";
const Wrapper = forwardRef((props, ref) => {
  const {
    pillStyle,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, {
    [wrapperPillStyleCss]: pillStyle
  }, props.className)} />;
});
export const AdminManagedBadge = ({
  groupManaged,
  pillStyle = false
}) => {
  const translatedString = groupManaged ? I18n.t('publisher.organization.managed_event_types.group_managed_badge') : I18n.t('publisher.organization.managed_event_types.admin_managed_badge');
  return <Wrapper pillStyle={pillStyle}>
      <StyledAdminIcon color={pillStyle ? colorTextStandard : colorIconSecondary} />
      <BodyText color={pillStyle ? colorTextStandard : 'muted'} size="medium">
        {translatedString}
      </BodyText>
    </Wrapper>;
};

require("./admin_managed_badge.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./admin_managed_badge.js");